module.exports = __webpack_public_path__ + "static/media/iit_bombay_logo.953a1a8a.png";